export default function /* @ngInject */ userCanFilter(userPermissions) {
    return function(action) {
        if (angular.isUndefined(action)) {
            // dynamic use
            return true;
        }
        return userPermissions.actions[action];
    };
}



// WEBPACK FOOTER //
// ./user/filters/user-can.filter.js